module.exports = __webpack_public_path__ + "static/media/GooglePayMark.235e7411.png";